export type PhoneType = 'UNKNOWN' | 'HOME' | 'CELL' | 'WORK' | 'FAX' | 'OTHER';

export type PhoneInput = {
  id?: string;
  subType: PhoneType;
  value: string;
  extension: string;
};

export type EmailType = 'UNKNOWN' | 'PERSONAL' | 'WORK' | 'OTHER';

export type EmailInput = {
  id?: string;
  subType: EmailType;
  value: string;
};

export type ProfileType = 'INDIVIDUAL' | 'COMPANY';

export type ContactProfileInput = {
  type: ProfileType;
  name?: string;
  firstName?: string;
  lastName?: string;
  contactAddressId?: string | null;
  billingAddressId?: string | null;
  phones: PhoneInput[];
  emails: EmailInput[];
};

export const profileTypes = [
  { value: 'COMPANY', label: 'Company' },
  { value: 'INDIVIDUAL', label: 'Individual' },
];
